import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Notebook panel art: a note in the editor. Title, three body lines, a two-item
 * bullet list, and the formatting strip along the bottom.
 *
 * The toolbar squares use `--muted-foreground` at low alpha rather than
 * `--muted`, which in the dark themes is all but the same value as `--card`.
 */

/** [line top y, width] */
const BODY_LINES: [number, number][] = [
  [30, 120],
  [40, 92],
]

/** [bullet row top y, bar width] */
const BULLETS: [number, number][] = [[54, 84]]

const TOOLBAR_X = [12, 26, 40]

export function NotebookArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      <rect x={12} y={12} width={70} height={8} rx={3} fill="hsl(var(--foreground) / 0.3)" />
      {BODY_LINES.map(([y, width]) => (
        <rect
          key={y}
          x={12}
          y={y}
          width={width}
          height={4.5}
          rx={2}
          fill="hsl(var(--foreground) / 0.13)"
        />
      ))}
      {BULLETS.map(([y, width]) => (
        <g key={y}>
          <circle cx={15} cy={y + 2.5} r={2.5} fill="hsl(var(--primary) / 0.7)" />
          <rect
            x={24}
            y={y}
            width={width}
            height={4.5}
            rx={2}
            fill="hsl(var(--foreground) / 0.16)"
          />
        </g>
      ))}
      {TOOLBAR_X.map((x) => (
        <rect
          key={x}
          x={x}
          y={76}
          width={10}
          height={8}
          rx={2}
          fill="hsl(var(--muted-foreground) / 0.3)"
        />
      ))}
    </svg>
  )
}
